<div class="page-layout blank p-24" fusePerfectScrollbar>

    <h2>{{'SAMPLE.HELLO' | translate}}</h2>
<!-- 
    <app-bar-chart [data]="data | async"></app-bar-chart> -->
    <app-shift-chart [data]="dataShift | async"></app-shift-chart>    
</div>
